import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'
import { ProjectConfigType } from '../Types'

export const useProjectConfig = () => {
  const p = ENDPOINTS.PROJECTS.CONFIG

  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  const response: ProjectConfigType = data?.data

  return {
    data: response,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
